import React, { Component } from 'react';
import Ionicon from "react-ionicons";
export const NAV_BAR_TITLE_ID = "nav_bar_title";

/*
Top navigation bar. Can be seen on every single page and holds the side nav toggle button
and page title as per Appwork's design.
*/
class NavBar extends Component {
  render() {
    const {location} = this.props

    return (
      <div className="layout-navbar navbar bg-white justify-content-start" id="layout-navbar">
        {
          (location.pathname !== "/") &&
          <div className="layout-sidenav-toggle navbar-nav d-lg-none">
            <a className="nav-link nav-item">
              <Ionicon icon="md-menu" className="sidenav-icon" color="black" />
            </a>
          </div>
        }
        <span className="text-large font-weight-bolder text-dark" id={NAV_BAR_TITLE_ID} />
      </div>
    )
  }
}

export default NavBar;



// WEBPACK FOOTER //
// ./src/views/components/navBar.js